export var CertificationType;
(function (CertificationType) {
    CertificationType["UNKNOWN"] = "UNKNOWN";
    CertificationType["VELO"] = "VELO";
    CertificationType["WEB_DESIGNER"] = "WEB_DESIGNER";
    CertificationType["ACCESSIBILITY"] = "ACCESSIBILITY";
    CertificationType["STUDIO_DEVELOPER"] = "STUDIO_DEVELOPER";
})(CertificationType || (CertificationType = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map